import { FC, ReactNode, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from 'src/components/SideBar';
import DashHeader from 'src/components/Headers/DashboardTitle';
import MenuIcon from '@mui/icons-material/Menu';
import {
  SidebarBackdrop,
  MobileMenuButton,
  MainContent,
  HeaderContainer,
  ActionToolbar,
  SearchContainer,
  ButtonContainer,
  ChildrenContainer,
} from 'src/components/StyledComponents/StyledPageComponents';

interface MainLayoutProps {
  title: string;
  children: ReactNode;
  searchBar?: ReactNode;
  button?: ReactNode;
  filterButton?: ReactNode;
}

const MainLayout: FC<MainLayoutProps> = ({
  title,
  children,
  searchBar,
  button,
  filterButton,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Box display="flex">
      {/* Refactored inline sx from lines 35-44 to SidebarBackdrop styled component */}
      {isMobile && isSidebarOpen && (
        <SidebarBackdrop onClick={() => setIsSidebarOpen(false)} />
      )}
      <Sidebar
        mobileOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />
      {/* Refactored inline sx from lines 54-64 to MobileMenuButton styled component */}
      {isMobile && !isSidebarOpen && (
        <MobileMenuButton onClick={toggleSidebar}>
          <MenuIcon />
        </MobileMenuButton>
      )}
      {/* Refactored inline sx from lines 76-79 to MainContent styled component */}
      <MainContent isMobile={isMobile}>
        {/* Refactored inline sx from lines 81-88 to HeaderContainer styled component */}
        <HeaderContainer>
          <DashHeader title={title} showAvatar={true} />
        </HeaderContainer>
        <ActionToolbar isMobile={isMobile}>
          {/* Refactored inline sx from lines 101-105 to SearchContainer styled component */}
          <SearchContainer isMobile={isMobile}>
            {searchBar && <Box>{searchBar}</Box>}
            {filterButton && <Box>{filterButton}</Box>}
          </SearchContainer>

          {button && (
            <ButtonContainer isMobile={isMobile}>{button}</ButtonContainer>
          )}
        </ActionToolbar>
        <ChildrenContainer>{children}</ChildrenContainer>
      </MainContent>
    </Box>
  );
};

export default MainLayout;
